import React, { useState, useEffect } from "react";
import { SessionVerification } from "../../../Components/SessionManagement/SessionManagement";
import CustHeader from '../../../Components/header/Header2/CustHeader'
import CustomerSideBar from "../../../Components/sidebar/CustomerSideBar";
import Footer from "../../../Components/Footer/Footer";
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion'
import { Box, Stack, Paper, Divider, Typography, Button } from "@mui/material";
import CustPurchaseTable from "../../Component/CustPurchaseOrder/CustPurchaseTable";
import http from "../../../services/http";
import configServ from '../../../services/config';

const CustPurchaseOrder = () => {
    //#region code
    const { user_id, company_id } = useSelector((state) => state.GlobalVariables);
    const open = useSelector((state) => state.sideExpand.open)
    const [tableData, setTableData] = useState([]);
    const [miniLoader, setMiniLoader] = useState(false);
    const PayLoad = {
        "company_id": company_id,
        "customer_id": user_id
    }

    useEffect(() => {
        fetchTableData()
    }, []);

    const fetchTableData = async () => {
        try {
            const result = await configServ.customer_order_list(PayLoad);
            // console.log('po',result.data.length)
            setTableData(result.data)
        } catch (err) {
            console.log(err)
        }
    }
    //#endregion

    return (
        <>
            <SessionVerification />
            <CustHeader />
            <CustomerSideBar />
            <Box sx={{
                marginLeft: {
                    xs: 7,
                    sm: 8,
                },
                ...(open && { marginLeft: 33 }),
                transition: '200ms',
                minHeight: '77vh',
                backgroundColor: '#EEEEEE77'
            }}>
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                >
                    <Paper
                        sx={{
                            width: '90%',
                            margin: 5,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            padding: 3,
                            pb: 5
                        }}
                    >
                        <motion.h4 style={{ textAlign: 'center' }}
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.1 }}
                        >
                            Purchase Order List
                        </motion.h4>
                        <Stack direction='column' justifyContent='flex-start' width='100%' my={2}>
                            <Divider />
                        </Stack>
                        {tableData !== undefined && (<CustPurchaseTable tableData={tableData} miniLoader={miniLoader} />)}
                    </Paper>
                </Stack>
            </Box>
            <Footer />

        </>
    )
};
export default CustPurchaseOrder;